import firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDJZuvnwrK-CwqFjKsUNAzXFDwzrgE5_nM",
    authDomain: "creatoverse.firebaseapp.com",
    projectId: "creatoverse",
    storageBucket: "creatoverse.appspot.com",
    messagingSenderId: "634011570611",
    appId: "1:634011570611:web:3d1713d194744c27b13bc6"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// DATABASE
var db = firebase.firestore();
var storage = firebase.storage();
var auth = firebase.auth();

export { db, storage, auth };
export default firebase;